import { getOneTrustActiveGroupsIds } from './getOneTrustActiveGroupsIds';

/**
 * Utility function to check if a cookie is allowed based on OneTrust groups.
 *
 * @param cookieName - The name of the cookie to check.
 *
 * @return {boolean} - Returns true if the cookie is allowed, false otherwise.
 */
export const isAllowedCookie = (cookieName: string): boolean => {
  const activeGroups = getOneTrustActiveGroupsIds();
  const domainData = window.OneTrust?.GetDomainData()?.Groups || [];

  return domainData.some(
    group =>
      activeGroups.includes(group.OptanonGroupId) &&
      group.Cookies?.some(cookie => cookie.Name === cookieName)
  );
};
